import React from 'react';

import ProfileDetailedBio from 'components/ProfileDetailedBio/ProfileDetailedBio';


const DetailedBio = () => (
  <div style={{ marginBottom: '30px' }}>
    <ProfileDetailedBio />
  </div>
);

export default DetailedBio;
